<template>
    <div class="popup">
        <div class="popup-content">
            <div class="content-wrap">
                <div class="header-pfnr">
                    <strong>Proforma Number</strong>
                    <strong>&nbsp;:&nbsp;</strong>
                    <i18n-t
                        v-if="
                            order.backoffice_reference == undefined ||
                            order.backoffice_reference == null
                        "
                        keypath="myOrders.notYetAvailable"
                    />
                    <span else>
                        {{ order.backoffice_reference }}
                    </span>
                    <div>
                        <img
                            src="/img/close-btn.svg"
                            class="close-popup-btn"
                            @click="closePopup"
                        />
                    </div>
                </div>
                <div class="pdf-container">
                    <PdfApp
                        @pages-rendered="pagesRendered"
                        v-show="pdf !== ''"
                        :pdf="pdf"
                        pageScale="page-height"
                        style="height: 100vh; width: 83vh"
                        :config="pdfConfig"
                    ></PdfApp>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
:global(:root) {
    --popup-header-height: 34px;
}
.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    position: relative;
    gap: 20px;
    height: 98%;
    padding-left: 20px;
    padding-top: 20px;
    padding-right: 20px;
    background: rgba(247, 249, 251, 1);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 4px;
}

.header-pfnr {
    margin-bottom: 20px;
    line-height: var(--popup-header-height);
    letter-spacing: 0.01em;
    text-align: left;

    font-family: var(--font-family);
    font-size: 28px;
    font-weight: 500;
    letter-spacing: 0.01em;
    text-align: left;
}

.pdf-container {
    /* width: 80vh; */
    height: calc(97% - var(--popup-header-height));
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow-y: hidden;
}
</style>

<script lang="ts">
import { ProformaPopup } from "@/dashboard/my-orders/new-popup/proforma-popup/proforma-popup";

export default ProformaPopup;
</script>
